export default "__VITE_ASSET__jw_8jKwn__"